export const DATA_RIGHT_TYPE = [{
    value: 'ALL',
    label: '全部'
  },
  {
    value: 'REGION',
    label: '区域'
  },
  {
    value: 'APPLIER',
    label: '申请单位'
  },
  {
    value: 'WORKYARD',
    label: '工地'
  },
  {
    value: 'LESSOR',
    label: '租赁单位'
  }
]

export const DASHBOARD_MODULE = [{
    value: 1,
    label: '按区域统计'
  },
  {
    value: 2,
    label: '按安装单位统计'
  },
  {
    value: 3,
    label: '按使用单位统计'
  },
  {
    value: 4,
    label: '按工地统计'
  },
]